import { LocationDates, WeekDay } from 'pages/my-calendars/add-calendar'

export const depthStyle: { [key: string]: { width: string } } = {
    'depth-0': { width: '250px' },
    'depth-1': { width: '230px' },
    'depth-2': { width: '210px' },
    'depth-3': { width: '190px' }
}

export const disableDatesConfig: { [key: string]: 'unavailableDays' | 'orderDays' } = {
    lastOrderDate: 'orderDays',
    firstOrderDate: 'orderDays',
    deliveryDate: 'orderDays',
    orderDate: 'unavailableDays'
}

export const datesConfig: { [key: string]: (keyof LocationDates)[] } = {
    lastOrderDate: ['lastOrderDate', 'firstOrderDate', 'deliveryDate', 'orderDate'],
    firstOrderDate: ['firstOrderDate', 'deliveryDate', 'orderDate'],
    deliveryDate: ['deliveryDate', 'orderDate'],
    orderDate: ['orderDate']
}

export const childToParentTypeConfig: { [key: string]: string } = {
    store: 'cluster',
    cluster: 'region',
    region: 'all'
}

export const prevDaysMap: Record<WeekDay, WeekDay> = {
    Monday: 'Sunday',
    Tuesday: 'Monday',
    Wednesday: 'Tuesday',
    Thursday: 'Wednesday',
    Friday: 'Thursday',
    Saturday: 'Friday',
    Sunday: 'Saturday'
}
